





































import { Component, Vue, Prop } from "vue-property-decorator";
import PicView from "@/components/pic-preview.vue";
@Component({
  components: {
    PicView,
  },
})
export default class SjkDanxuan extends Vue {
  @Prop()
  private question;
  @Prop()
  private index;
  @Prop()
  private filters;
  private ifShowPic: boolean = false;
  private index2Alpha: any[] = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
  ];
  private pieOption: any = {
    color: ["#52CF82", "#F76857", "#23AEB8"],
    legend: {
      data: [],
      right: 0,
      orient: "vertical",
      top: "30%",
    },
    series: [
      {
        type: "pie",
        center: ["30%", "50%"],
        radius: ["40%", "50%"],
        data: [],
        label: {
          show: true,
          formatter: "{b}:{c}",
        },
      },
    ],
  };
  private mounted() {
    this.pieOption["series"][0].data = this.question["统计图"]["data"];
    this.pieOption["legend"]["data"] = this.question["统计图"]["name"];
  }
}
